import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/vegan_ham_and_cheese_croissant_jalapeno.png";
import useMetaTracking from "../hooks/useMetaTracking";

function VeganHamAndCheeseCroissantJalapeno() {
  useMetaTracking("ViewContent", {
    content_name: "Vegan Ham & Cheese Jalapeno Croissant",
    content_category: "Vegan Menu",
    content_ids: ["vegan_ham_and_cheese_jalapeno_croissant"],
    content_type: "vegan_pastries",
    value: 4.75,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>
          Vegan Ham & Cheese Jalapeño Croissant | Đông Hưng Viên Bakery
        </title>
        <meta
          name="description"
          content="Our Vegan Ham & Cheese Croissant just got a whole lot hotter!"
        />
        <meta
          property="og:title"
          content="Vegan Ham & Cheese Jalapeño Croissant | Đông Hưng Viên Bakery"
        />
        <meta
          property="og:description"
          content="Our Vegan Ham & Cheese Croissant just got a whole lot hotter!"
        />
      </Helmet>

      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="VEGAN HAM & CHEESE JALAPEÑO CROISSANT"
          titleSubHead="$4.75 each"
          detailBody="Our Vegan Ham & Cheese Croissant just got a whole lot hotter. Packed with savory vegan hams, gooey vegan cheese, and a burst of jalapeño heat! "
          detailBodyBr="Contains: wheat, soy, almond"
          detailBody3="Available now!"
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default VeganHamAndCheeseCroissantJalapeno;